import { makeStyles } from '@material-ui/core';

export const getProposalEditorWrapperStyles = makeStyles(() => ({
  loaderContainer: {
    height: '100%',
    width: '100%',
  },
}));
